/** 4.2 Round button: raised disc with a 22 px icon and an optional ochre dot (the only unread indicator). */
import type { MouseEvent, ReactElement } from "react";
import { Link } from "react-router-dom";
import { Icon } from "./Icon";

export interface RoundButtonProps { icon: string; label: string; size?: 44 | 40 | 36 | 52; dot?: boolean; onClick?: (e: MouseEvent<HTMLElement>) => void; to?: string; className?: string; id?: string; pressed?: boolean }
export function RoundButton({ icon, label, size = 44, dot = false, onClick, to, className = "", id, pressed }: RoundButtonProps): ReactElement {
  const cls = `rb ${size !== 44 ? `rb--${size}` : ""} ${className}`;
  const inner = <>
    <Icon name={icon} size={22} stroke={2} />
    {dot && <span className="rb__dot" aria-hidden="true" />}
  </>;
  if (to) return <Link to={to} className={cls} aria-label={dot ? `${label}, new` : label} id={id} onClick={onClick as (e: MouseEvent<HTMLAnchorElement>) => void}>{inner}</Link>;
  return <button type="button" className={cls} aria-label={dot ? `${label}, new` : label} aria-pressed={pressed} id={id} onClick={onClick}>{inner}</button>;
}
